<script setup>
import {usePageApi} from '~/composables/api/usePageApi'
import {useRoute} from 'nuxt/app'
import SourceCtasBlockComponent from '~/components/pages/blocks/SourceCtasBlockComponent.vue'
import TextPhotoCtaBlockComponent from '~/components/pages/blocks/TextPhotoCtaBlockComponent.vue'
import FullWidthTitleTextBlockComponent from '~/components/pages/blocks/FullWidthTitleTextBlockComponent.vue'
import VideoGalleryBlockComponent from '~/components/pages/blocks/VideoGalleryBlockComponent.vue'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import RequestCourseInfoBlockComponent from '~/components/pages/blocks/RequestCourseInfoBlockComponent.vue'
import SliderBlockComponent from '~/components/pages/blocks/SliderBlockComponent.vue'
import ContactFormBlockComponent from '~/components/pages/blocks/ContactFormBlockComponent.vue'
import {useAuthStore} from '~/store/auth'
import MapBlockComponent from '~/components/pages/blocks/MapBlockComponent.vue'
import ImageBlockComponent from '~/components/pages/blocks/ImageBlockComponent.vue'
import KeyItemsBlockComponent from '~/components/pages/blocks/KeyItemsBlockComponent.vue'
import LinkItemsBlockComponent from '~/components/pages/blocks/LinkItemsBlockComponent.vue'

const asyncComponents = {
  //'MosaicCtasBlock': () => import('~/components/pages/blocks/MosaicCtasBlockComponent.vue'),
  'SliderBlock': SliderBlockComponent,
  'SourceCtasBlock': SourceCtasBlockComponent,
  'TextPhotoCtaBlock': TextPhotoCtaBlockComponent,
  'FullWidthTitleTextBlock': FullWidthTitleTextBlockComponent,
  'VideoGalleryBlock': VideoGalleryBlockComponent,
  'RequestCourseInfoBlock': RequestCourseInfoBlockComponent,
  'ContactFormBlock': ContactFormBlockComponent,
  'MapBlock': MapBlockComponent,
  'ImageBlock': ImageBlockComponent,
  'KeyItemsBlock': KeyItemsBlockComponent,
  'LinkItemsBlock': LinkItemsBlockComponent
}

const currentRoute = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const config = useRuntimeConfig()
const notification = useNotification()

const pageBlocks = computed(() => {
  return data.value?.blocks || []
})
const pageMetadata = computed(() => {
  return data.value?.metadata || {}
})

const {data, error} = await useAsyncData(`page-${currentRoute.path}`, async () => {
  const pageApi = usePageApi()

  return await pageApi.getBySlug(currentRoute.path)
})

if (!data.value || error.value) {
  throw createError({statusCode: 404, statusMessage: 'page_not_found', fatal: true})
}

console.info(data.value)

useCustomSEOData({
  title: data.value.seo.title,
  meta: [
    {
      name: 'description',
      content: data.value.seo.description,
    },
    {
      name: 'robots',
      content: data.value.seo.robots,
    }
  ]
})

const breadcrumbs = computed(() => {
  return [
    {label: 'Inicio', link: '/'},
    {label: data.value.title, link: currentRoute.path}
  ]
})

function getBlockComponent(block) {
  return asyncComponents?.[block.type]
}

async function checkAccess() {
  if (!pageMetadata.value.requiresAuth) return

  const userRoles = authStore.user?.roles || []
  if (!pageMetadata.value?.roles?.some(role => userRoles.includes(role))) {
    notification.showError('No tienes permisos para acceder a esta página')
    await router.replace('/')
  }
}

onBeforeMount(async () => {
  await checkAccess()
})
</script>

<template>
  <div v-if="data">
    <div class="grid grid-cols-12 text-[#363330]">
      <div class="col-span-12">
        <h1 class="text-2xl lg:text-4xl font-bold italic px-4 lg:px-8 underline text-[#363330] mt-5">
          {{ data.title }}
        </h1>
        <BreadCrumb class="px-4 xl:px-8" :items="breadcrumbs"/>
      </div>
    </div>
    <div class="grid grid-cols-12">
      <template v-for="block in pageBlocks" :key="block.id">
        <component class="video-block mb-0 mt-0" :is="getBlockComponent(block)" :data="block"/>
      </template>
    </div>
  </div>
</template>
